
import { defineComponent, ref, computed, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("合成列表", ["合成管理;compounds"])
    })

    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const tableData = ref([]);
    const activeTab = ref((route.query.compound_type as string) || "product");
    const allCategories = ref<{ id: number; name: string; compound_type: string }[]>([]);
    const categoryOptions = computed(() => {
      if (!activeTab.value) return allCategories.value;
      return allCategories.value.filter((c) => c.compound_type === activeTab.value);
    });

    const formData = ref({
      name: "",
      enabled: "",
      compound_category_id: "",
    });

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    });

    const query = () => {
      const params: Record<string, unknown> = {
        ...formData.value,
        ...page.value,
      };
      if (activeTab.value) {
        params.compound_type = activeTab.value;
      }
      store
        .dispatch(Actions.GET_COMPOUNDS, params)
        .then(() => {
          tableData.value = store.getters.currentCompounds
          page.value.totalResult = store.getters.currentCompoundCount
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        });
    };

    // 加载分类选项
    store.dispatch(Actions.GET_COMPOUND_CATEGORIES, { pageSize: 999 }).then(() => {
      allCategories.value = store.getters.currentCompoundCategories;
    });

    query()

    const newCompound = () => {
      router.push({ name: "compound_new", query: { compound_type: activeTab.value || "product" } })
    }

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage
      query()
    }

    const onTabChange = () => {
      page.value.currentPage = 1;
      formData.value.compound_category_id = "";
      const q = { ...route.query };
      if (activeTab.value) {
        q.compound_type = activeTab.value;
      } else {
        delete q.compound_type;
      }
      router.replace({ query: q });
      query();
    };

    const onSearch = () => {
      page.value.currentPage = 1;
      query();
    };

    const onReset = () => {
      formData.value.name = "";
      formData.value.enabled = "";
      formData.value.compound_category_id = "";
      page.value.currentPage = 1;
      query();
    };

    const onSortingChange = (row) => {
      store
        .dispatch(Actions.UPDATE_COMPOUND, {
          id: row.id,
          values: { sorting: row.sorting },
        })
        .then(() => {
          query();
        });
    };

    const onDelete = (id) => {
      Swal.fire({
        title: '确认删除？',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: '确认',
        // denyButtonText: '取消',
        cancelButtonText: '取消'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          store
            .dispatch(Actions.DELETE_COMPOUND, id)
            .then(() => {
              query()
            })
            .catch(() => {
              // const [error] = Object.keys(store.getters.getErrors);
              // Swal.fire({
              //   text: store.getters.getErrors[error],
              //   icon: "error",
              //   buttonsStyling: false,
              //   confirmButtonText: "Try again!",
              //   customClass: {
              //     confirmButton: "btn fw-bold btn-light-danger",
              //   },
              // });
            })
          // Swal.fire('Saved!', '', 'success')
        // } else if (result.isDenied) {
          // Swal.fire('Changes are not saved', '', 'info')
        }
      })
    }

    const formatPrice = (price: number | string | null | undefined): string => {
      if (price === null || price === undefined) return '0.0'
      const num = Number(price)
      return isNaN(num) ? '0.0' : num.toFixed(1)
    }

    return {
      tableData,
      formData,
      activeTab,
      categoryOptions,
      newCompound,
      page,
      onPageChange,
      onTabChange,
      onSearch,
      onReset,
      onSortingChange,
      onDelete,
      formatPrice
    }
  },
})
